import type { CreatePropertyInput, UpdatePropertyInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import {
  createProperty,
  deleteProperty,
  updateProperty
} from '../services/properties-admin.service'

export const useCreatePropertyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreatePropertyInput) => await createProperty(payload),
    onSuccess: () => {
      toast.success('Inmueble creado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.properties.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdatePropertyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdatePropertyInput }) =>
      await updateProperty(id, payload),
    onSuccess: () => {
      toast.success('Inmueble actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.properties.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeletePropertyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteProperty(id),
    onSuccess: () => {
      toast.success('Inmueble eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.properties.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
